import dayjs from "dayjs";
import { useState } from "react";

import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import { DeadPatientsByPlaceFilters } from "./DeadPatientsByPlaceFilters";
import { DeadPatientsByPlaceTable } from "./DeadPatientsByPlaceTable";

import { useCurrentAccount } from "@/hooks/useCurrentAccount";
import { ResumeGrouped } from "@/services/esus/attendanceService";
import { getAggregatedDeadPatientsByPlace } from "@/services/sintegrada/patient/getAggregatedDeadPatientsByPlace";
import { PlaceOfOccurrenceEnum } from "@/utils/enums/PlaceOfOccurrenceEnum";

export function DeadPatientsByPlace() {
	const { uf, ibgeCode, cnes } = useCurrentAccount();
	const [startDate, setStartDate] = useState(
		dayjs().add(-1, "month").startOf("day").format("YYYY-MM-DDTHH:mm")
	);
	const [endDate, setEndDate] = useState(dayjs().endOf("day").format("YYYY-MM-DDTHH:mm"));
	const [youngerAge, setYoungerAge] = useState<number>();
	const [olderAge, setOlderAge] = useState<number>();
	const [aggregatedDeadPatientsByPlace, setAggregatedDeadPatientsByPlace] = useState<
		ResumeGrouped<PlaceOfOccurrenceEnum | null, object>[]
	>([]);

	async function fetchData() {
		setAggregatedDeadPatientsByPlace(
			await getAggregatedDeadPatientsByPlace({
				uf,
				ibgeCode,
				cnes,
				startDate: dayjs(startDate)
					.tz(Intl.DateTimeFormat().resolvedOptions().timeZone)
					.startOf("minute")
					.format("YYYY-MM-DDTHH:mm:ssZ"),
				endDate: dayjs(endDate)
					.tz(Intl.DateTimeFormat().resolvedOptions().timeZone)
					.endOf("minute")
					.format("YYYY-MM-DDTHH:mm:ssZ"),
				youngerAge,
				olderAge,
			})
		);
	}

	return (
		<>
			<Row className="p-2 mb-10">
				<Col>
					<DeadPatientsByPlaceFilters
						startDate={startDate}
						setStartDate={setStartDate}
						endDate={endDate}
						setEndDate={setEndDate}
						setYoungerAge={setYoungerAge}
						setOlderAge={setOlderAge}
						handleFilter={fetchData}
					/>
				</Col>
			</Row>
			<Row className="p-2">
				<Col>
					<DeadPatientsByPlaceTable
						aggregatedDeadPatientsByPlace={aggregatedDeadPatientsByPlace}
					/>
				</Col>
			</Row>
		</>
	);
}
